import React, {Component} from 'react';
import {
    Grid,
    Typography,
    Paper,
    Table
} from 'material-ui';
import TableUserPermissionsHeader from './TableUserPermissionsHeader';
import TableUserPermissionsInputs from './TableUserPermissionsInputs';

class UserPermissionsDisplayTable extends Component {

    render() {
        const {
            userName,
            userId,
            groupedPermissions,
            userPermissionsIds,
            classes
        } = this.props;

        return (
            <Grid className="userPermissions" container spacing={0}>
                <Grid item xs={12}>
                    <Typography variant="title" className={classes.userPermissionsLead}>{userName}'s Permissions</Typography>
                </Grid>
                <Paper className={classes.root}>
                    <Table className={classes.root}>
                        <TableUserPermissionsHeader
                            groupedPermissions={groupedPermissions}
                            classes={classes}
                        />
                        <TableUserPermissionsInputs
                            userPermissionsIds={userPermissionsIds}
                            groupedPermissions={groupedPermissions}
                            userId={userId}
                            classes={classes}
                        />
                    </Table>
                </Paper>
            </Grid>
        )
    }
}

export default UserPermissionsDisplayTable;


// WEBPACK FOOTER //
// ./src/containers/users/forms/UserPermissionsDisplayTable.jsx